<template>
  <v-form
    ref="form"
    lazy-validation
  >
    <v-card>
      <v-card-title v-if="title">
        <span class="text-h3">{{ $t(title) }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col
              v-if="authUser.isAdmin"
              cols="12"
              sm="6"
            >
              <v-autocomplete
                v-model="options.product"
                dense
                :disabled="type == 'edit'"
                :items="['oem', 'fleet']"
                item-text="name"
                item-value="id"
                :label="$t('select_product_*')"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col
              v-if="authUser.isAdmin"
              cols="6"
              sm="6"
            >
              <v-autocomplete
                v-model="options.tenant"
                dense
                :loading="tenantLoading"
                :items="
                  options.product
                    ? options.product == 'oem'
                      ? tenantsOEM
                      : tenantsFLEET
                    : []
                "
                :disabled="type == 'edit'"
                item-text="name"
                item-value="id"
                :label="$t('select_tenant_*')"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-autocomplete
                v-model="options.vehicles"
                dense
                :loading="isVehicle"
                :items="vehicleList"
                item-text="name"
                item-value="id"
                :label="$t('select_vehicles_*')"
                multiple
                :rules="[rules.multi_select_required]"
              >
                <template v-slot:selection="data">
                  <span
                    v-if="data.index === 0"
                    class="selected"
                  >
                    <span>{{ data.item.name }}</span>
                  </span>
                  <span
                    v-if="data.index === 1"
                    class="grey--text text-caption"
                  >
                    (+{{ options.vehicles.length - 1 }} others)
                  </span>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-autocomplete
                v-model="options.from_geofence"
                dense
                :items="geofenceList"
                item-value="id"
                item-text="name"
                :label="$t('from_geofence_*')"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-autocomplete
                v-model="options.add_stops"
                dense
                :items="geofenceList"
                item-value="id"
                item-text="name"
                :label="$t('to_geofence_*')"
                multiple
                return-object
                :rules="[rules.multi_select_required]"
              >
                <template v-slot:selection="data">
                  <span
                    v-if="data.index === 0"
                    class="selected"
                  >
                    <span>{{ data.item.name }}</span>
                  </span>
                  <span
                    v-if="data.index === 1"
                    class="grey--text text-caption"
                  >
                    (+{{ options.add_stops.length - 1 }} others)
                  </span>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="options.cutoff_time"
                dense
                type="time"
                placeholder="Enter Cutoff Time"
                :label="$t('cutoff_time_*')"
                :rules="[rules.required]"
              />
            </v-col>

            <!--  -->
            <v-col
              v-if="options.from_geofence"
              cols="12"
              sm="12"
            >
              <div class="text-h4 d-flex align-center justify-space-between">
                <div>
                  Departure:
                  <b> {{ getGeofenceName(options.from_geofence) }}</b>
                </div>
                <div>
                  <span>
                    Total SLA: <b> {{ total_sla }} hours</b></span>
                  <span>
                    Total Stops: <b> {{ options.add_stops?.length || 0 }}</b>
                  </span>
                </div>
              </div>
            </v-col>
            <!-- <v-card
             
              class="mr-2"
            >
              <v-card-text
                class="d-flex align-center gap-2 py-1"
              >
              
                Start From
              </v-card-text>
              <v-card-title class="py-1">
                {{ options.from_geofence }}
              </v-card-title>
            </v-card> -->
            <v-col
              cols="12"
              sm="12"
            >
              <draggable
                v-model="options.add_stops"
                class="row"
                group="people"
                @start="drag = true"
                @end="drag = false"
              >
                <v-col
                  v-for="(element, i) in options.add_stops"
                  :key="element.id"
                  cols="4"
                  sm="4"
                >
                  <v-card style="cursor: pointer">
                    <v-card-text>
                      <div class="d-flex align-center justify-space-between">
                        <div
                          v-if="i == options.add_stops.length - 1"
                          class="d-flex align-center gap-2 py-1"
                        >
                          <Icons :name="`marker-end`" />
                          End Stop
                        </div>
                        <div
                          v-else
                          class="d-flex align-center gap-2 py-1"
                        >
                          <Icons :name="`marker-${i + 1}`" />
                          Stop: {{ i + 1 }}
                        </div>
                        <div>
                          <b>{{ element.name }}</b>
                        </div>
                      </div>
                      <div>
                        <v-text-field
                          v-model="element.sla_target"
                          dense
                          type="number"
                          filled
                          placeholder="Enter SLA in hours"
                          :label="`SLA for ${element.name}`"
                          :rules="[rules.required]"
                        />
                      </div>
                      <div>
                        <v-text-field
                          v-model="element.break_duration"
                          dense
                          type="number"
                          filled
                          placeholder="Duration in hours"
                          :label="`Break Duration for ${element.name}`"
                          :rules="[rules.lessThan(element.sla_target || 0)]"
                        />
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </draggable>
            </v-col>
            <!--  -->
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <small v-if="!readOnly">{{ $t("indicates_required_field") }}</small>
        <v-spacer />
        <v-btn
          color="red darken-1"
          text
          @click="closeForm()"
        >
          Close
        </v-btn>
        <v-btn
          v-if="!readOnly"
          color="primary"
          text
          :loading="loading"
          @click="saveItem"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import { validationRules } from "@/mixins/validationRules";
import { mapGetters } from "vuex";
//
import { debounce } from "lodash";
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
    Icons: () => import("@/components/base/icons.vue"),
  },
  mixins: [validationRules],

  props: {
    type: {
      type: String,
      default() {
        return {
          time: null,
        };
      },
    },
    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },
    readOnly: {
      type: Boolean,
      default() {
        return false;
      },
    },
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      options: {},
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      tenantLoading: "tenantsManagement/getIsLoading",
      tenantsList: "tenantsManagement/getTenantOptions",
      tenantsOEM: "tenantsManagement/getTenantsOEM",
      tenantsFLEET: "tenantsManagement/getTenantsFLEET",
      //
      isVehicle: "vehicles/getIsLoadingVehicles",
      vehicleList: "vehicles/getVehiclesList",
      //
      geofenceList: "geofence/getList",
    }),
    title() {
      if (this.readOnly) {
        return "view";
      }
      if (this.type == "create") {
        return "add_new";
      } else if (this.type == "edit") {
        return "edit";
      } else {
        return "";
      }
    },
    total_sla() {
      const count_sla_target = this.options?.add_stops?.map(
        (r) => r.sla_target || 0
      );
      const total = count_sla_target?.reduce(
        (a, c) => parseFloat(a || 0) + parseFloat(c || 0),
        0
      );
      return total;
    },
  },
  watch: {
    "options.tenant": {
      handler: async function (val) {
        if (this.type == "create") this.fetchDependents(val);
      },
    },
  },
  async beforeMount() {
    if (this.type == "create") {
      if (!this.authUser.isAdmin) {
        this.options.tenant = this.authUser.tenant_id;
        this.fetchDependents(this.authUser.tenant_id);
      }
      // this.options.currency = "PKR";
    }

    if (this.type == "edit") {
      this.options = { ...this.item };
      this.fetchDependents(this.item.tenant);

      const stp = this.item.stops.map((r) => ({
        ...r,
        route_id: r.id,
        id: r.geofence,
      }));
      let countSLA =
        stp?.reduce(
          (a, c) => parseFloat(a || 0) + parseFloat(c.sla_target || 0),
          0
        ) || 0;
      stp.push({
        id: this.item.to_geofence,
        name: this.item.to_name,
        sla_target: this.item.sla_target - countSLA,
      });

      //for rendering stops in the form
      this.$set(this.options, "add_stops", stp);
    }
  },
  methods: {
    getVehicleList: debounce(async function (params) {
      await this.$store.dispatch("vehicles/list", {
        ...params,
        compare_route: true,
      });
    }, 500),

    getGeofenceList(params) {
      this.$store.dispatch("geofence/list", params);
    },
    saveItem() {
      if (this.$refs.form.validate()) {
        const opt = { ...this.options };
        opt.sla_target = this.total_sla;
        //
        if (opt.add_stops.length > 1) {
          opt.stops = opt.add_stops.map((r, i) => ({
            id: r.id,
            geofence: r.id,
            sequence: i + 1,
            name: r.name,
            sla_target: r.sla_target,
            break_duration: r.break_duration,
          }));
          opt.stops.pop();
        } else {
          opt.stops = [];
        }
        //
        opt.to_geofence = opt.add_stops[opt.add_stops.length - 1].id;
        delete opt.add_stops;

        this.$emit("onsave", opt);
      }
    },
    closeForm() {
      // this.$refs.form.reset();
      this.$emit("onclose");
    },

    async fetchDependents() {
      const params = {
        tenant_id: this.options.tenant,
      };
      if (params.tenant_id) {
        this.getVehicleList(params);
        this.getGeofenceList(params);
      }
    },

    //
    getGeofenceName(id) {
      return this.geofenceList.find((r) => r.id == id)?.name ?? "";
    },
    //
  },
};
</script>
<style lang="sass" scoped>
.connectorsRow

  display: flex
  gap:1rem
  .field
    min-width:150px !important
    max-width:165px !important


.deleteButton
  cursor: pointer
  .deleteIcon
    &:hover
      color: red
</style>
